import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-form-panel',
    styleUrls: ['formpanel.component.scss'],
    templateUrl: 'formpanel.component.html'
})

export class FormPanelComponent implements OnChanges, OnDestroy {

    @Input() IsNominee: boolean;
    @Input() Section: FormGroup;

    ViewReady: boolean;

    constructor() {
        this.ViewReady = false;
    }

    ngOnDestroy() {

    }

    ngOnChanges() {
        this.ViewReady = true;
    }

    UpdateCheckbox(event: MatCheckboxChange, Question: FormGroup) {
        if (!event || !Question) { return; }

        const newVal = (event.checked === true ? true : null);

        Question.get('Response').setValue(newVal);
	}

	displayText(txt: string): string {
		let res: string;
		switch (txt) {
			case '<FirstName>': {
				res = '<strong>' + this.Section.get('Questions').value[0].FirstName; + '</strong>'
				break;
			}
			case '<LastName>': {
				res = '<strong>' + this.Section.get('Questions').value[0].LastName; + '</strong>'
				break;
			}
			default: {
				res = txt;
				break;
			}
		}
		
		return `${res}`;
	};
}
